// extracted by mini-css-extract-plugin
export default {"Root":"zx8Nq8QVmNNNrfVVFZwY","TableContainer":"SQqmYhz4ATSxwe8ZirO0"};